// Components
import Button from "../../../../General/Components/Button";

// Icons
import { Envelope } from "phosphor-react";

// Images
import LockedPattern from "../../../../../Assets/Images/locked-pattern.png";

// Other
import React from "react";

const CallToAction = ({
  title,
  Icon,
  rowSpan,
  colSpan,
  disabled,
  description,
  location,
}) => {
  return (
    <section
      className={`p-3 bg-dark-500 rounded-lg ${
        rowSpan ? "row-span-" + rowSpan : "row-span-1"
      } ${colSpan ? "col-span-" + colSpan : "col-span-1"} ${
        disabled ? "relative" : ""
      }`}
    >
      <section className="flex flex-col h-full justify-between">
        {/* Locked Image */}
        {disabled ? (
          <img
            src={LockedPattern}
            alt="Locked Pattern"
            className="absolute top-0 left-0 w-full opacity-50"
          />
        ) : (
          ""
        )}
        <section className="flex items-center w-full justify-between">
          <h1 className="text-lg text-text-dark-500">{title}</h1>
          {Icon ? (
            <section className="bg-brand-500/50 w-[50px] h-[50px] rounded-full flex items-center justify-center">
              <Icon size={27.5} className="text-brand-500" weight="bold" />
            </section>
          ) : (
            <></>
          )}
        </section>

        <p className="text-text-dark-500 text-sm">{description}</p>
        <Button
          title="Log out"
          Icon={Envelope}
          action={() => {
            window.location.href = "mailto:mirelise.social@gmail.com";
          }}
        />
      </section>
    </section>
  );
};

export default CallToAction;
